<form class="ui form" #form="ngForm">
    <ng-container *ngIf="schedule?.allPeriods">
        <ng-container *ngIf="jurisdictionFilter">
            <div class="app-grid">
                <mat-form-field class="columns-12">
                    <mat-label appRemoveAriaOwns>{{
                        'components.form-filter-payroll-report.jurisdiction' | translate
                    }}</mat-label>
                    <mat-select
                        name="jurisdictionSelect"
                        #jurisdictionSelect="ngModel"
                        [(ngModel)]="jurisdiction"
                        (ngModelChange)="calculateDateRange()"
                    >
                        <mat-option *ngFor="let jurisdiction of this.jurisdictions" [value]="jurisdiction.value">
                            {{ jurisdiction.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="jurisdictionSelect.invalid">{{ jurisdictionSelect.errors | formErrors }}</mat-error>
            </div>
        </ng-container>

        @if (filter !== 'allTime') {
            <div class="app-grid">
                <mat-form-field class="columns-12">
                    <mat-label appRemoveAriaOwns>{{
                        'components.form-filter-payroll-report.year' | translate
                    }}</mat-label>
                    <mat-select
                        name="yearSelect"
                        required
                        #yearSelect="ngModel"
                        [(ngModel)]="year"
                        (ngModelChange)="calculateDateRange('year')"
                    >
                        <mat-option *ngFor="let period of this.schedule.allPeriods" [value]="period.year">{{
                            period.year
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="yearSelect.invalid">{{ yearSelect.errors | formErrors }}</mat-error>
            </div>
        }

        <ng-container *ngIf="year && shouldShowFilterBy">
            <div class="app-grid">
                <label id="filter-by">{{ 'components.form-filter-payroll-report.filterBy' | translate }}</label>
                <mat-radio-group
                    name="filterBy"
                    aria-labelledby="filter-by"
                    class="vertical"
                    [(ngModel)]="filter"
                    (ngModelChange)="calculateDateRange()"
                >
                    @if (showAllTimeOption) {
                        <mat-radio-button value="allTime">
                            {{ 'components.form-filter-payroll-report.allTime' | translate }}
                        </mat-radio-button>
                    }
                    <mat-radio-button value="annual">
                        {{ 'components.form-filter-payroll-report.annual' | translate }}
                    </mat-radio-button>
                    <mat-radio-button *ngIf="getSelectYear()?.quarters?.length" value="quarter">
                        {{ 'components.form-filter-payroll-report.quarter' | translate }}
                    </mat-radio-button>
                    <mat-radio-button *ngIf="getSelectYear()?.quarters?.length" value="month">
                        {{ 'components.form-filter-payroll-report.month' | translate }}
                    </mat-radio-button>
                    <mat-radio-button
                        *ngIf="getSelectYear()?.payPeriods?.length && !isJournalEntryV2Report"
                        value="payPeriods"
                    >
                        {{ 'components.form-filter-payroll-report.payPeriods' | translate }}
                    </mat-radio-button>
                    <mat-radio-button
                        *ngIf="isJournalEntryV2Report && journalEntryReportPayPeriodOptions.length"
                        value="payPeriodsJournalEntryReport"
                    >
                        {{ 'components.form-filter-payroll-report.payPeriods' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="app-grid">
                <ng-container *ngIf="getSelectYear()?.quarters?.length">
                    <ng-container *ngIf="filter === 'quarter'">
                        <mat-form-field class="columns-12">
                            <mat-label appRemoveAriaOwns>{{
                                'components.form-filter-payroll-report.selectQuarter' | translate
                            }}</mat-label>
                            <mat-select
                                name="quarterSelect"
                                [(ngModel)]="quarter"
                                #quarterSelect="ngModel"
                                required
                                (ngModelChange)="calculateDateRange()"
                            >
                                <mat-option *ngFor="let quarter of getSelectYear()?.quarters" [value]="quarter">
                                    Q{{ quarter }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="quarterSelect.invalid">{{ quarterSelect.errors | formErrors }}</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="filter === 'month'">
                        <mat-form-field class="columns-12">
                            <mat-label appRemoveAriaOwns>{{
                                'components.form-filter-payroll-report.selectMonth' | translate
                            }}</mat-label>
                            <mat-select
                                name="monthSelect"
                                [(ngModel)]="month"
                                #monthSelect="ngModel"
                                required
                                (ngModelChange)="calculateDateRange()"
                            >
                                <mat-option *ngFor="let month of getSelectYear()?.months" [value]="month">
                                    {{ monthMap[month - 1] | translate }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="monthSelect.invalid">{{ monthSelect.errors | formErrors }}</mat-error>
                        </mat-form-field>
                    </ng-container>
                </ng-container>

                <ng-container
                    *ngIf="getSelectYear()?.payPeriods?.length && filter === 'payPeriods' && !isJournalEntryV2Report"
                >
                    <mat-form-field class="columns-12">
                        <mat-label appRemoveAriaOwns>{{
                            'components.form-filter-payroll-report.selectPeriod' | translate
                        }}</mat-label>
                        <mat-select
                            name="periodSelect"
                            [(ngModel)]="period"
                            #periodSelect="ngModel"
                            required
                            (ngModelChange)="calculateDateRange()"
                        >
                            <mat-option *ngFor="let payPeriod of getSelectYear()?.payPeriods" [value]="payPeriod">
                                <!-- Off Cycle and YearEndAdjustment do not have Period Number prefix -->
                                {{ typesWithoutPrefix.includes(payPeriod.type) ? '' : 'P' + payPeriod.periodNo + ' '
                                }}{{ payPeriodLabel(payPeriod) | translate }} ({{ payPeriod.chequeDate }})
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="periodSelect.invalid">{{ periodSelect.errors | formErrors }}</mat-error>
                    </mat-form-field>
                </ng-container>

                <ng-container
                    *ngIf="
                        filter === 'payPeriodsJournalEntryReport' &&
                        isJournalEntryV2Report &&
                        journalEntryReportPayPeriodOptions.length
                    "
                >
                    <mat-form-field class="columns-12">
                        <mat-label appRemoveAriaOwns>{{
                            'components.form-filter-payroll-report.selectPeriod' | translate
                        }}</mat-label>
                        <mat-select
                            name="journalEntryPeriodSelect"
                            [(ngModel)]="selectedJournalEntryReportPayPeriod"
                            #journalEntryPeriodSelect="ngModel"
                            required
                        >
                            <mat-option
                                *ngFor="let journalEntryReportPayPeriodOption of journalEntryReportPayPeriodOptions"
                                [value]="journalEntryReportPayPeriodOption"
                            >
                                {{ journalEntryReportPayPeriodOption.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="journalEntryPeriodSelect.invalid">{{
                            journalEntryPeriodSelect.errors | formErrors
                        }}</mat-error>
                    </mat-form-field>
                </ng-container>

                <mat-checkbox
                    *ngIf="report?.allowsInclusionOfPendingPayrolls"
                    color="primary"
                    name="include_pending"
                    class="columns-12 align-left"
                    [(ngModel)]="includePending"
                    >{{ 'components.form-filter-payroll-report.includePendingPayroll' | translate }}</mat-checkbox
                >
            </div>
        </ng-container>
    </ng-container>
</form>
